import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseComponent } from './core-app/base/base.component';
import { AuthGuard } from './guard/auth.guard';
import { DashboardComponent } from './core-app/dashboard/dashboard.component';
import { RecordComponent } from './core-app/record/record.component';
import { AccountSettingsComponent } from './core-app/settings/account-settings/account-settings.component';
import { NotificationsComponent } from './core-app/settings/notifications/notifications.component';
import { PasswordComponent } from './core-app/settings/password/password.component';
import { SettingsComponent } from './core-app/settings/settings.component';

import { RoleGuard } from './guard/role.guard';
import { PermissionsGuard } from './guard/permissions.guard';
import { ErrorPageComponent } from './core-app/error-page/error-page.component';
import { EditIndividualRecordComponent } from './core-app/record/edit-individual-record/edit-individual-record.component';


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./core/core.module').then(m => m.CoreModule)
  },

  { 
    path:'app', component:BaseComponent,
    children:[
    //  { path:'', loadChildren: () => import('./core-app/core-app.module').then(m => m.CoreAppModule)}
     { path: 'dashboard', component: DashboardComponent,
     data:{
       allowedRoles:[
         "Dashboard"
       ]
     },
     canActivate:[RoleGuard]
   },
   
   { 
     path:'records',
     loadChildren: () => import('./core-app/user-record/user-record.module').then(m => m.UserRecordModule),
     canActivate:[AuthGuard]
 
   },
   { 
     path:'users',
     loadChildren: () => import('./core-app/user-manager/user-manager.module').then(m => m.UserManagerModule),
     canActivate:[AuthGuard]
 
   },
   
   { path: 'settings', component: SettingsComponent,
     children:[
       {path: '', component: AccountSettingsComponent},
       {path: 'notifications', component: NotificationsComponent},
       {path: 'password', component: PasswordComponent},
     ],
     data:{
       allowedRoles:[
         "Settings"
       ]
     },
     canActivate:[RoleGuard]
   },
   
  
   
  
   // { path:'catalog', component:CatalogueComponent,
   //   data:{
   //     allowedRoles:[
   //       "Dashboard"
   //     ]
   //   },
   //   canActivate:[RoleGuard]
   // },
   { path:'', redirectTo: 'dashboard', pathMatch: 'prefix'},
 
   {path: 'error', component: ErrorPageComponent},
   {path: '**', redirectTo: 'error'},
    ],
    canActivate:[AuthGuard]

  },
  
  
  // {
  //   path: 'app',
  //   loadChildren: () => import('./core-app/core-app.module').then(m => m.CoreAppModule)
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
